module.exports = __webpack_public_path__ + "mobile/img/img_home_list_banner4.52d965d7.png";